import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import SupportGroupsIndex from '../SupportGroupsIndex/SupportGroupsIndex';
import SupportGroupSlides from '../SupportGroupSlides/SupportGroupSlides';
import './SupportGroupFeed.scss';
var SupportGroupFeed = function (props) {
    var UI = useControllers().UI;
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "SupportGroupFeed" }, UI.onlyPhones
            ? React.createElement(SupportGroupSlides, null)
            : React.createElement("div", { className: "container" },
                React.createElement(SupportGroupsIndex, { showFilters: true, defaultMode: "calendar", appearanceOptions: {
                        fullHeight: true,
                    } })))); } });
};
export default SupportGroupFeed;
